// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileTextTwoToneSvg from "@ant-design/icons-svg/es/asn/FileTextTwoTone";
import AntdIcon from '../components/AntdIcon';

var FileTextTwoTone = function FileTextTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileTextTwoToneSvg
  }));
};

FileTextTwoTone.displayName = 'FileTextTwoTone';
export default React.forwardRef(FileTextTwoTone);